<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';
import TagInput from 'dashboard/components-next/taginput/TagInput.vue';
import { INPUT_TYPES } from 'dashboard/components-next/taginput/helper/tagInputHelper.js';
import AudienceFields from './AudienceFields.vue';
import WhatsAppContactsRecipientsPicker from '../Pages/CampaignPage/WhatsAppCampaign/WhatsAppContactsRecipientsPicker.vue';
import WhatsAppBroadcastListPicker from '../Pages/CampaignPage/WhatsAppCampaign/WhatsAppBroadcastListPicker.vue';

defineProps({
  inboxId: { type: [Number, String], default: null },
  labels: { type: Array, default: () => [] },
  messagingTier: { type: String, default: '' },
});

const audienceIds = defineModel('audienceIds', {
  type: Array,
  default: () => [],
});
const recipientMode = defineModel('recipientMode', {
  type: String,
  default: 'labels',
});
const phoneNumbers = defineModel('phoneNumbers', {
  type: Array,
  default: () => [],
});
const broadcastListId = defineModel('broadcastListId', {
  type: Number,
  default: null,
});
const { t } = useI18n();
const options = computed(() => [
  {
    value: 'labels',
    label: t('CAMPAIGN.WHATSAPP.CREATE.FORM.RECIPIENT_MODE.OPTIONS.LABELS'),
  },
  {
    value: 'saved_contacts',
    label: t(
      'CAMPAIGN.WHATSAPP.CREATE.FORM.RECIPIENT_MODE.OPTIONS.SAVED_CONTACTS'
    ),
  },
  {
    value: 'phone_list',
    label: t('CAMPAIGN.WHATSAPP.CREATE.FORM.RECIPIENT_MODE.OPTIONS.PHONE_LIST'),
  },
  {
    value: 'broadcast_list',
    label: t(
      'CAMPAIGN.WHATSAPP.CREATE.FORM.RECIPIENT_MODE.OPTIONS.BROADCAST_LIST'
    ),
  },
  {
    value: 'all_inbox',
    label: t('CAMPAIGN.WHATSAPP.CREATE.FORM.RECIPIENT_MODE.OPTIONS.ALL_INBOX'),
  },
]);
</script>

<template>
  <div class="flex flex-col gap-3">
    <label for="recipient-mode" class="text-heading-3 text-n-slate-12">
      {{ t('CAMPAIGN.WHATSAPP.CREATE.FORM.RECIPIENT_MODE.LABEL') }}
    </label>
    <ComboBox id="recipient-mode" v-model="recipientMode" :options="options" />
    <p class="text-body-main text-n-slate-11">
      {{ t('CAMPAIGN.WHATSAPP.CREATE.FORM.RECIPIENT_MODE.INFO') }}
    </p>
    <AudienceFields
      v-if="recipientMode === 'labels'"
      v-model="audienceIds"
      :labels="labels"
      :messaging-tier="messagingTier"
    />
    <TagInput
      v-else-if="recipientMode === 'phone_list'"
      v-model="phoneNumbers"
      :type="INPUT_TYPES.TEL"
      :placeholder="t('CAMPAIGN.WHATSAPP.CREATE.FORM.PHONE_LIST.PLACEHOLDER')"
      allow-create
    />
    <WhatsAppContactsRecipientsPicker
      v-else-if="recipientMode === 'saved_contacts' && inboxId"
      v-model="phoneNumbers"
      :inbox-id="Number(inboxId)"
    />
    <WhatsAppBroadcastListPicker
      v-else-if="recipientMode === 'broadcast_list' && inboxId"
      v-model="broadcastListId"
      :inbox-id="Number(inboxId)"
    />
    <p
      v-else-if="recipientMode === 'all_inbox'"
      class="text-body-main text-n-slate-11"
    >
      {{ t('CAMPAIGN.WHATSAPP.CREATE.FORM.ALL_INBOX.INFO') }}
    </p>
  </div>
</template>
